import { useState, useEffect } from 'react';
import { client } from 'graphql/client';
import { GET_WAREHOUSE_BY_ID, GetWarehouseByIdResponse } from 'graphql/queries/warehouseQueries';

export const useWarehousePickupZones = (warehouseId?: number) => {
    const [pickupZones, setPickupZones] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!warehouseId) {
            setPickupZones([]);
            return;
        }

        const fetchPickupZones = async () => {
            setLoading(true);
            setError(null);
            try {
                const { data } = await client.query<GetWarehouseByIdResponse>({
                    query: GET_WAREHOUSE_BY_ID,
                    variables: { id: warehouseId },
                });

                if (data?.warehouse?.pickupZoneZipcodeList) {
                    setPickupZones(data.warehouse.pickupZoneZipcodeList);
                } else {
                    setPickupZones([]);
                }
            } catch (err) {
                console.error('Error fetching warehouse pickup zones:', err);
                setError('Failed to load pickup zones');
                setPickupZones([]);
            } finally {
                setLoading(false);
            }
        };

        fetchPickupZones();
    }, [warehouseId]);

    return {
        pickupZones,
        loading,
        error
    };
}; 